import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaLink from 'components/essentials/Cta/CtaLink';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';
import ContentfulImage from '../ConsumerBlogSlider/components/ContentfulImage/ContentfulImage';
const LargeImageOverlapText = props => {
  const $ = _c(36);
  const {
    isMobileOrTablet
  } = useScreen();
  const {
    imageProps,
    headLine,
    subHeadLine,
    bodyText,
    primaryButton,
    secondaryLink,
    imageOrientation,
    additionalClasses
  } = props.config;
  let finalOrientation = "default";
  if (imageOrientation && imageOrientation.value) {
    finalOrientation = imageOrientation.value !== "Image Right" ? "alt" : "default";
  }
  const t0 = finalOrientation === "alt";
  const t1 = finalOrientation === "default";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = classNames("flex w-full mx-auto my-0", {
      "flex-row-reverse max-[767px]:flex-col": t0,
      "flex-row max-[767px]:flex-col-reverse": t1
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = finalOrientation === "alt";
  let t4;
  if ($[3] !== additionalClasses.heading || $[4] !== t3) {
    t4 = classNames("bg-white flex flex-col content-center justify-center font-sans max-[767px]:w-full max-[767px]:text-center", {
      "max-[767px]:!pb-6": t3
    }, additionalClasses.heading || "");
    $[3] = additionalClasses.heading;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== headLine.content) {
    t5 = <h1 className="text-3xl font-bold text-gray text-left m-0">{headLine.content}</h1>;
    $[6] = headLine.content;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== subHeadLine) {
    t6 = subHeadLine && subHeadLine.content && <h2 className="text-xl font-bold mt-6 mx-0 mb-0 text-gray text-left">{subHeadLine.content}</h2>;
    $[8] = subHeadLine;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== bodyText) {
    t7 = bodyText && bodyText.content && <p className="text-base mt-3 mx-0 mb-6 text-gray text-left">{bodyText.content}</p>;
    $[10] = bodyText;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isMobileOrTablet || $[13] !== primaryButton) {
    t8 = !!primaryButton && primaryButton.content && <CtaLink to={primaryButton.linkTo} color="brand" size={isMobileOrTablet ? "sm" : "md"} styling="solid-button">{" "}{primaryButton.content}</CtaLink>;
    $[12] = isMobileOrTablet;
    $[13] = primaryButton;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isMobileOrTablet || $[16] !== secondaryLink) {
    t9 = !!secondaryLink && secondaryLink.content && <CtaLink to={secondaryLink.linkTo} arrow={true} light={true} size={isMobileOrTablet ? "sm" : "base"}>{secondaryLink.content}</CtaLink>;
    $[15] = isMobileOrTablet;
    $[16] = secondaryLink;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="pt-4 flex items-center max-[767px]:p-[5px] max-[767px]:justify-center">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t11 = <div className="max-[767px]:w-full w-[55%] flex flex-row pt-6 pr-12 pb-6 pl-0 transform-[translateX(3.333vw)] bg-white m-0 md:pt-12 md:pr-12 md:pb-12 md:pl-0 md:mx-0 md:my-20 xl:w-[35%] max-[767px]:transform-none"><div className={t4}>{t5}{t6}{t7}{t10}</div></div>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== imageProps.alt || $[28] !== imageProps.blogImage || $[29] !== imageProps.src || $[30] !== props.lazy) {
    t12 = <div className="max-[767px]:w-full w-[70%] [&_img]:w-full [&_img]:align-middle [&_img]:[transition:all_0.25s_ease-in-out] [&_img]:h-screen [&_img]:max-h-[65vh]">{imageProps.blogImage ? <ContentfulImage src={imageProps.src} alt={imageProps.alt} lazy={props.lazy} className="object-cover" /> : <JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="70vw" lazy={props.lazy} />}</div>;
    $[27] = imageProps.alt;
    $[28] = imageProps.blogImage;
    $[29] = imageProps.src;
    $[30] = props.lazy;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t2) {
    t13 = <div className={t2}>{t11}{t12}</div>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t2;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
export const LargeImageOverlapTextConfigPropType = PropTypes.shape({
  imageProps: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    blogImage: PropTypes.bool
  }),
  headLine: PropTypes.shape({
    content: PropTypes.string
  }),
  subHeadLine: PropTypes.shape({
    content: PropTypes.string
  }),
  bodyText: PropTypes.shape({
    content: PropTypes.string
  }),
  primaryButton: PropTypes.shape({
    content: PropTypes.string,
    linkTo: PropTypes.string
  }),
  secondaryLink: PropTypes.shape({
    content: PropTypes.string,
    linkTo: PropTypes.string
  }),
  imageOrientation: PropTypes.shape({
    value: PropTypes.string
  }),
  additionalClasses: PropTypes.shape({
    heading: PropTypes.string
  })
});
LargeImageOverlapText.propTypes = {
  lazy: PropTypes.bool,
  config: LargeImageOverlapTextConfigPropType
};
export default LargeImageOverlapText;